import React, { useRef, useState, useEffect } from 'react';
import { ReactReader } from 'react-reader';


const NewEpub = () => {
    const [selections, setSelections] = useState([])
    const [size, setSize] = useState(100)
    const [location, setLocation] = useState(null)
    const [page, setPage] = useState('')
    const renditionRef = useRef(null)
    const tocRef = useRef(null)


    const locationChanged = epubcifi => {
        if (renditionRef.current && tocRef.current) {
            const { displayed, href } = renditionRef.current.location.start
            const chapter = tocRef.current.find(item => item.href === href)
            setPage(
                `Page ${displayed.page} of ${displayed.total}  ${chapter ? chapter.label : ''
                }`
            )
            setLocation(epubcifi)
        }
    }



    const handleSizeChange = (event) => {
        setSize(event.target.value);
    };

    useEffect(() => {
        if (renditionRef.current) {
            renditionRef.current.themes.fontSize(`${size}%`);
        }
    }, [size, renditionRef]);


    useEffect(() => {
        if (renditionRef.current) {
            renditionRef.current.themes.fontSize(`${size}%`)
        }
    }, [size])

    useEffect(() => {
        if (renditionRef.current) {
            function setRenderSelection(cfiRange, contents) {
                setSelections(
                    selections.concat({
                        text: renditionRef.current.getRange(cfiRange).toString(),
                        cfiRange
                    })
                )
                renditionRef.current.annotations.add(
                    'highlight',
                    cfiRange,
                    {},
                    null,
                    'hl',
                    { fill: 'red', 'fill-opacity': '0.5', 'mix-blend-mode': 'multiply' }
                )
                contents.window.getSelection().removeAllRanges()
            }
            renditionRef.current.on('selected', setRenderSelection)
            return () => {
                renditionRef.current.off('selected', setRenderSelection)
            }
        }
    }, [setSelections, selections])

    const [selectedOption, setSelectedOption] = useState(null);

    const handleOptionClick = (option) => {
        setSelectedOption(option);
    };





    return (
        <>
           
            <section className='pdf-viewer'>
                <div className='container'>
                    <div className='row my-4'>

                        <div className="col-md-12">
                            <ul className="navbar-list justify-content-end">
                                <li className="epub-setting navbar-item dropdown">
                                    <button className=" btn-6 view-all-btn setting_icon">
                                        <span><i className="fas fa-cogs"></i></span>
                                    </button>
                                    <ul className="dropdown-position-list">
                                        <li><button className="lg-out" onClick={() => handleOptionClick('selection')}>selection</button></li>
                                        <li><button className="lg-out" onClick={() => handleOptionClick('page')}>Show Number of Pages</button></li>
                                        <li><button className="lg-out" onClick={() => handleOptionClick('font')}>Change Font Size</button></li>
                                    </ul>

                                </li>
                            </ul>


                            <div className="content">
                                {selectedOption === 'selection' && <div className="ab-content">
                                    <div>
                                        <div className='p_selection'>

                                            <ul>
                                                <li> Selection:</li>
                                                {selections.map(({ text, cfiRange }, i) => (
                                                    <li key={i}>
                                                        {text}{' '}

                                                        <button className='cross_btn' onClick={() => {
                                                            renditionRef.current.annotations.remove(cfiRange, 'highlight')
                                                            setSelections(selections.filter((item, j) => j !== i))
                                                        }}
                                                        >
                                                            <i className="fas fa-times"></i>
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>

                                    </div>
                                </div>}
                                {selectedOption === 'page' && <div className="bc-content">{page}</div>}
                                {selectedOption === 'font' && <div className="cd-content">

                                    <div className='mb-3'>
                                        <label htmlFor='fontSizeRange'>Adjust Font Size: </label>
                                        <input
                                            type='range'
                                            id='fontSizeRange'
                                            min='80'
                                            max='150'
                                            value={size}
                                            onChange={handleSizeChange}
                                            style={{ width: '200px' }}
                                        />

                                    </div>
                                </div>}
                            </div>
                        </div>
                        <div className='col-md-12 mt_0 py-4 text-upper books_section'>


                            <div style={{ position: 'relative', height: '90vh' }}>
                                <ReactReader
                                    location={location}
                                    locationChanged={locationChanged}
                                    url="https://react-reader.metabits.no/files/alice.epub"
                                    epubInitOptions={{
                                        openAs: 'epub'
                                    }}
                                    tocChanged={toc => (tocRef.current = toc)}

                                    getRendition={rendition => {
                                        renditionRef.current = rendition
                                        renditionRef.current.themes.default({
                                            '::selection': {
                                                background: 'orange'
                                            }
                                        })
                                        setSelections([])
                                    }}
                                />
                            </div>



                        </div>
                    </div>
                </div>
            </section>
        </>

    );
};

export default NewEpub;
